module.exports = __webpack_public_path__ + "img/comiendo.4f1cae67.png";